import { Controller } from "@hotwired/stimulus"

// Order form: quantity stepper + live total (price from the Article), and the
// "different shipping address" toggle.
export default class extends Controller {
  static targets = ["qty", "total", "shipping"]
  static values = { price: { type: Number, default: 0 } }

  connect() {
    this.update()
    this.syncShipping()
  }

  increment() {
    this.qtyTarget.value = Math.min(99, this.current() + 1)
    this.update()
  }

  decrement() {
    this.qtyTarget.value = Math.max(1, this.current() - 1)
    this.update()
  }

  current() {
    return parseInt(this.qtyTarget.value, 10) || 1
  }

  update() {
    if (!this.hasTotalTarget) return
    const total = this.current() * this.priceValue
    this.totalTarget.textContent = `CHF ${this.fmt(total)}.–`
  }

  fmt(n) {
    return Math.round(n).toLocaleString("de-CH").replace(/,/g, "'")
  }

  toggleShipping(event) {
    if (this.hasShippingTarget) this.shippingTarget.style.display = event.target.checked ? "block" : "none"
  }

  syncShipping() {
    if (!this.hasShippingTarget) return
    const cb = this.element.querySelector('input[type="checkbox"][name="order[ship_to_different]"]')
    this.shippingTarget.style.display = cb && cb.checked ? "block" : "none"
  }
}
